import { acquireTokenSilent } from './acquireTokenSilent';

export const createGetAuthToken = (account, instance) => () => acquireTokenSilent(account, instance)
  .then(result => new Promise(resolve => resolve(result.accessToken)));
